import { render, staticRenderFns } from "./UploadTrack.vue?vue&type=template&id=35dba6f6&scoped=true&"
import script from "./UploadTrack.vue?vue&type=script&lang=js&"
export * from "./UploadTrack.vue?vue&type=script&lang=js&"
import style0 from "./UploadTrack.vue?vue&type=style&index=0&id=35dba6f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dba6f6",
  null
  
)

export default component.exports